import { render, staticRenderFns } from "./AddSphere.vue?vue&type=template&id=1739729f&scoped=true"
import script from "./AddSphere.vue?vue&type=script&lang=js"
export * from "./AddSphere.vue?vue&type=script&lang=js"
import style0 from "./AddSphere.vue?vue&type=style&index=0&id=1739729f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1739729f",
  null
  
)

export default component.exports